export enum InvoiceStatus {
  ATUAL = 'Atual',
  PROXIMA = 'Próxima'
}

type StatusOptions = {
  [key: string]: number;
};

type valueof<T> = T[keyof T];

export const STATUS: StatusOptions = {
  FECHADA: 0,
  ABERTA: 1
};

export interface InvoicePurchases {
  date: string;
  description: string;
  fullPriceReais: number;
  howManyInstallments: number;
  itauTimezone: string;
  origin: string;
  priceReais: number;
  dateString?: string;
  fullPriceInternational: string;
  USDExchangeRate: number;
  currency: string;
  currentInstallment: number;
  isChargeBack?: boolean;
}

export interface InvoiceInterface {
  id: number;
  minimumValue: number;
  itauTimezone: string;
  closingInvoiceDate: string;
  value: number;
  valueFormatted?: string;
  dueDate: string;
  dueDateString?: string;
  bestBuyingDate: string;
  status: InvoiceStatus;
  statusPayment: string;
  statusMapped?: valueof<StatusOptions>;
  installmentPurchasesTotal: number;
  nationalPurchasesTotal: number;
  internationalPurchasesTotal: number;
  topPurchases: InvoicePurchases[];
  cardDigits: string;
  previousInvoiceValue: number;
  iofTotal: number;
  totalForeignWithdraw: number;
  chargesAndServices: number;
  paid: boolean;
  remainingBalance: number;
  lastInvoicePayment: number;
  invoiceMonth: string;
}
